import React from 'react';

import {
  Box,
  Grid,
  Paper,
  Typography
} from '@mui/material';

import CalendarPanel from './components/CalendarPanel';
import RemindersPanel from './components/RemindersPanel';
import AppointmentContent from './components/AppointmentContent';
import PageHeaderTabs from '../Common/components/PageHeaderTabs';
import {
  patientPageContentSx,
  patientPageRootSx
} from '../Common/components/Styles/PatientPageStyles';

const paperSx = {
  p: 1.5,
  bgcolor: '#FFFFFF',
  borderRadius: '8px',
  border: '1px solid #E0E0E0',
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
};

const leftPanelSx = {
  pr: {
    xs: 0,
    md: 1
  }
};

const rightPanelSx = {
  pl: {
    xs: 0,
    md: 1
  },
  mt: {
    xs: 2,
    md: 0
  }
};

const PTSchedule = () => {
  return (
    <Box sx={patientPageRootSx}>
      <PageHeaderTabs type="title" title="Appointments" />
      <Box sx={patientPageContentSx}>
        <Paper sx={paperSx}>
          <Grid container>
            <Grid
              size={{
                xs: 12,
                md: 3
              }}
              sx={leftPanelSx}
            >
              <CalendarPanel />
              <RemindersPanel />
            </Grid>

            <Grid
              size={{
                xs: 12,
                md: 9
              }}
              sx={rightPanelSx}
            >
              <AppointmentContent />
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </Box>
  );
};

export default PTSchedule;